import { WGS_API_BASE_URL } from '@/core/constants/appConfig/environment';
import { ScriptHandler } from '@/core/handlers/script/index';

import {
  baseFetchClient,
  FetchClientOptions,
  FetchClientResponse,
} from './base_client';

/**
 * Makes an API call to the WGS API, automatically adding the UID parameter
 * and using the WGS_API_BASE_URL as the base URL.
 */
export async function callWgsAPI<T = any>(
  options: FetchClientOptions,
  overrideDomain?: string,
  useRelativeUrl?: boolean,
): Promise<FetchClientResponse<T>> {
  // Add source UID to params
  const uid = ScriptHandler.getInstance().getSourceUid();
  const updatedParams = {
    ...options.params,
    uid,
  };

  return baseFetchClient<T>(
    {
      ...options,
      params: updatedParams,
    },
    overrideDomain || WGS_API_BASE_URL,
    useRelativeUrl,
  );
}
